import React from 'react'
import "./Loader.css"
export const Loader = ({style}) => {
  return (
    <span class="loader" style={style}></span>
  )
}
